import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

interface Identification {
  status: 'REJECTED' | 'VERIFIED' | 'PENDING' | string
  image: string
}

interface Identifications {
  passport: Identification
  selfie: Identification
}

interface CountryTitle {
  fa: string
  en: string
}

interface CountryAvailability {
  registration: boolean
  transaction: boolean
}

interface Country {
  id: string
  title: CountryTitle
  callingCode: number
  iso: string
  flagUrl: string
  availability: CountryAvailability
}

interface Document {
  id: number
  user_id: number
  national_code: string
  status: 'VERIFIED' | 'REJECTED' | 'PENDING' | string
  created_at: string
  updated_at: string
  deleted_at: string | null
}

interface Statistics {
  requisitions: number
  receivedOffers: number
  sentOffers: number
  inProgressTransactions: number
}

interface LoggedInUser {
  accessToken: string
  refreshToken: string | null
  id: string
  userId: number
  shortReferralLink: string
  referral_code: string
  fullName: string
  email: string
  mobile: string
  photo_uploaded: boolean
  identifications: Identifications
  flagUrl: string
  created_at: string
  country: Country
  national_code: string
  document: Document
  status: 'VERIFIED' | 'REJECTED' | 'PENDING' | string
  isUserOld: number
  credit: number
  statistics: Statistics
}

export function emailLoginAction(payload: {
  email: string
  password: string
  remember: boolean
}): Promise<ApiResponse<LoggedInUser>> {
  return api.post<ApiResponse<LoggedInUser>>('/auth/login/email', { ...payload })
}
